import Grid from '@blocks/Grid'
import Select from '@blocks/Select'
import List from '@components/modules/List'
import React from 'react'
import SectionElement from './components/SectionElement'

export default function JuryForm({ juries, sections, model: jury }: Modules.Resource.Form<Admin.Resources.Jury> & Props) {
    const defaultValue = jury ? { label: jury.name, value: jury.user_id.toString() } : undefined
    
    return (
        <Grid>
            <Select id="user_id" name="user_id" label="Jury" options={juries} value={defaultValue} />
            <Grid gap="10px">
                <b>Sections</b>
                <List items={jury?.sections} element={SectionElement} options={{ sections }} />
            </Grid>
        </Grid>
    )
}

interface Props {
    juries: Interfaces.Options | undefined
    sections: Interfaces.Options | undefined
}